import { useState } from 'react';
import './DayCell.css';
import NewEvent from '../NewEvent/NewEvent';

export default function DayCell({ date, events, onAddEvent, calendar, onUpdateEvent, canWrite }) {
    const [hover, setHover] = useState(false);
    const [showDialog, setShowDialog] = useState(false);
    const [editingEvent, setEditingEvent] = useState(null);

    const allEvents = Array.isArray(events) ? events : [];

    const dayEvents = allEvents.filter(ev => {
        if (!date || !ev?.start || !ev?.end) return false;

        const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());

        const s = new Date(ev.start); // <- ev.start kann String ODER Date sein
        const e = new Date(ev.end);

        if (isNaN(+s) || isNaN(+e)) return false;

        const start = new Date(s.getFullYear(), s.getMonth(), s.getDate());
        const end = new Date(e.getFullYear(), e.getMonth(), e.getDate());

        if (ev.recurrence === 'none' || !ev.recurrence) {
            return d >= start && d <= end;
        }
        switch (ev.recurrence) {
            case 'daily': return d >= start;
            case 'weekly': return d >= start && d.getDay() === start.getDay();
            case 'monthly': return d >= start && d.getDate() === start.getDate();
            case 'yearly': return d >= start && d.getDate() === start.getDate() && d.getMonth() === start.getMonth();
            default: return d >= start && d <= end;
        }
    });


    // console.log('Rendering DayCell for', date, 'with events:', dayEvents);
    // console.log('All events:', allEvents);
    // console.log('Calendar:', calendar);

    const handleAddEvent = (event) => {

        if (!canWrite(calendar.id)) return;

        onAddEvent(event);
    };
    const handleUpdate = (updatedEvent) => {
        if (!canWrite(calendar.id)) return;
        
        onUpdateEvent(calendar.id, updatedEvent);
    };


    return (
        <div
            className="day-cell"
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
        >
            {date ? <div className="day-number">{date.getDate()}</div> : <div>&nbsp;</div>}

            {canWrite(calendar.id) && hover && date && (
                <button className="add-event-btn" onClick={() => setShowDialog(true)}>+</button>
            )}

            {showDialog && date && (
                console.log('Opening NewEvent dialog for date', calendar),
                <NewEvent
                    calendarId={calendar.id}
                    date={date}
                    onClose={() => { setShowDialog(false); setEditingEvent(null); }}
                    onSave={editingEvent ? handleUpdate : handleAddEvent}
                    initialEvent={editingEvent || null}
                    mode={editingEvent ? 'edit' : 'add'}
                />
            )}

            <div className="events">
                {dayEvents.map((e) => (
                    <div
                    key={e.id} 

                    onClick={() => {setShowDialog(true), setEditingEvent(e);}} 
                    className="event-item">
                        {
                            new Date(e.start).toLocaleTimeString([], {
                                hour: '2-digit', minute: '2-digit'
                            })} - {
                            new Date(e.end).toLocaleTimeString([], {
                                hour: '2-digit', minute: '2-digit'
                            })}

                        <strong>{e.title}</strong><br />
    
                    </div>
                ))}
            </div>
        </div>
    );
}
